// Lightbox open/close helpers — registered via context.functions so any
// element can dispatch them with:
//   el.call('openLightbox', { url, mime, name })
//   el.call('closeLightbox')
//
// AppLightbox lives as a body-only component (no backdrop, no positioning
// — those come from @symbo.ls/windows ModalLayer). State carrier remains
// `root.lightbox` so the body reads `s.root.lightbox?.{url,mime,name}` as
// before — only visibility moves to the layer.

const LIGHTBOX_LAYER_ID = 'app-lightbox'

const _rootState = (el) =>
  el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null

export function openLightbox(opts) {
  if (!opts?.url) return
  const root = _rootState(this)
  if (!root) return
  root.update({ lightbox: opts })
  // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default maxHeight
  // so the Close X can't be pushed off-screen by tall content / a short
  // viewport.
  // WS-MODAL-X-HORIZONTAL-OVERFLOW-1: the lightbox wants a WIDE window, so
  // the width goes on the layer descriptor (ModalLayer.js sizes ModalWindow
  // from it) instead of on the body. The body used to force `width: '90vw'`
  // inside a default-'H' window with `overflow: 'visible'` — it overflowed
  // the window, carrying its absolutely-positioned CloseBtn off-screen.
  this.call('openCustomModal', {
    id: LIGHTBOX_LAYER_ID,
    width: '90vw',
    maxWidth: '90vw',
    maxHeight: '90vh',
    content: { extends: 'AppLightbox' }
  })
}

export function closeLightbox() {
  const root = _rootState(this)
  root?.update({ lightbox: null })
  this.call('closeModal', LIGHTBOX_LAYER_ID)
}
